<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-tableLoading="tableLoading" :page="page"
                ref="crud" @row-save="handleSave" @row-update="handleSave" @search-change="searchChange"
                @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
                @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <!-- <el-button type="primary" size="small" plain @click.stop="handleAdd(scope.row, scope.index)">
                        <i class="el-icon-plus"></i>新增
                    </el-button> -->
                    <el-button type="success" icon="el-icon-download" size="mini" plain
                        @click.stop="downloadExcelmaterialOrder">下载汇总</el-button>
                        <el-button type="success" icon="el-icon-download" size="mini" plain
                        @click.stop="downloadExcelmaterialOrderDetails">下载明细</el-button>
                    <el-button type="danger" size="small" plain v-if="permission.JOINS_SALES_CLOUD_ELIVERY_DEL"
                        @click.stop="handleDel()">
                        <i class="el-icon-delete"></i>删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button
                        v-if="(scope.row.status == 'WAIT_FOR_DELIVERY' || scope.row.status == 'WAIT_FOR_ASSIGN') && permission.JOINS_SALES_CLOUD_ELIVERY_EDIT"
                        type="primary" size="small" plain @click.stop="handleEdit(scope.row, scope.index)">
                        <i class="el-icon-edit"></i>编辑
                    </el-button>
                    <el-button type="success" icon="el-icon-view" size="small" plain @click="handleView(scope.row)">查看
                    </el-button>
                    <el-button v-if="scope.row.type == 'WATERPROOF' && permission.JOINS_SALES_CLOUD_ELIVERY_DIARY"
                        type="primary" icon="el-icon-view" size="small" plain
                        @click="handleViewServiceDiary(scope.row)">日记
                    </el-button>
                </template>
                <template slot-scope="scope" slot="consigneeSignPic">
                    <viewer :images="formmaterImage(scope.row.consigneeSignPic)">
                        <img v-for="src in formmaterImage(scope.row.consigneeSignPic)" :src="src" :key="src" width="20">
                    </viewer>
                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-if="scope.row.status == 'WAIT_FOR_DELIVERY'" type="warning">待提货</el-tag>
                    <el-tag v-if="scope.row.status == 'INSTALLED'" type="info">已安装</el-tag>
                    <el-tag v-if="scope.row.status == 'WAIT_FOR_ASSIGN'" type="success">待指派</el-tag>
                    <el-tag v-if="scope.row.status == 'WAIT_INSTALL' && scope.row.type == 'PURE_WATER'"
                        type="warning">待安装</el-tag>
                    <el-tag v-if="scope.row.status == 'PARTIAL_INSTALLATION' && scope.row.type == 'PURE_WATER'"
                        type="warning">部分安装</el-tag>
                    <el-tag v-if="scope.row.status == 'COMPLETE' && scope.row.type == 'PURE_WATER'"
                        type="info">已完成</el-tag>
                    <el-tag
                        v-if="(scope.row.status == 'WAIT_INSTALL' || scope.row.status == 'WAIT_INSTALL_SECOND' || scope.row.status == 'WAIT_FOR_DELIVERY_SECOND' || scope.row.status == 'COMPLETE') && scope.row.type == 'WATERPROOF'"
                        type="info">已完成</el-tag>
                </template>
                <template slot-scope="scope" slot="realNameForm">
                    <el-select v-model="scope.row.realName" placeholder="请选择工程师" filterable remote
                        :remote-method="handleRemote" clearable>
                        <el-option v-for="item in users" :key="item.id" :label="item.realName" :value="item.id">
                        </el-option>
                    </el-select>
                </template>
                <!--选择前仓 -->
                <template slot-scope="scope" slot="warehouseNameForm">
                    <el-select v-model="scope.row.warehouseName" placeholder="请选择前仓" clearable @change="chooseWarehouse"
                        filterable>
                        <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { materialOrderOption } from "@/const/work/waterProof/materialStatisticsOptions";
import { findmaterialOrder, addmaterialOrder, updatematerialOrder,downloadExcelmaterialOrder,downloadExcelMaterialRetrievalDetails,delmaterialOrder } from "@/api/work/waterProof/materialStatistics";
import { findUserList } from "@/api/work/projectService";
import { resolveUrlPath } from "@/util/util";
import { getWarehouseList } from "@/api/salesCloud/warehouse";
export default {
    name: "materialStatisticsForm",
    data() {
        return {
            tableOption: materialOrderOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            superiorIds: [],
            superiorId: {},
            serviceCategoryName: {},
            categoryTypes: [],
            classifySelects: [],
            currClassify: [],
            tabelObj: {},
            users: [],
            warehouse: "",
            WarehouseList: [],
            ids: "",
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
        };
    },
    created() {
        this.handleList();
        // this.handleWarehouseList();
    },
    watch: {},
    mounted() { },
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        handleWarehouseList() {
            getWarehouseList().then((res) => {
                let data = JSON.parse(res.data);
                this.WarehouseList = data.rows;
            });
        },
        formmaterImage(row) {
            let str = new Array();
            JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        handleViewServiceDiary(row) {
            let obj = {
                label: "服务日记",
                value: "/work/eliveryOrder/serviceDiary",
                query: { id: row.id },
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: obj.query,
            });
        },
        handleView(row) {
            console.log('row::: ', row.engineerId);
            // 查看
            let obj = {
                label: "查看材料明细",
                value: "/work/waterProof/materialStatistics/view",
                query: { engineerId: row.engineerId, startTime: this.$refs.crud.searchForm.startTime, endTime: this.$refs.crud.searchForm.endTime },
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: obj.query,
            });
        },
        // handleRemote远程搜索工程师
        handleRemote(query) {
            // eslint-disable-next-line no-control-regex
            if (/[^\x00-\xff]/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            } else if (/^\d{8,}$/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            }
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            findmaterialOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;

            this.downloadData = params;
            findmaterialOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            this.downloadData = params;
            for (let key in params) {
                if (params[key] == null) {
                    params[key] = "";
                }
            }
            findmaterialOrder(params).then((res) => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size,
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        //eslint-disable-next-line
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;

            findmaterialOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.$refs.crud.rowAdd();
        },
        chooseWarehouse(val) {
            this.warehouse = this.WarehouseList.find((item) => item.id == val);
        },
        handleSave(row, addDone, done) {
            // 只允许在待提货、待指派状态下修改
            if (row.status != "WAIT_FOR_DELIVERY" && row.status != "WAIT_FOR_ASSIGN") {
                this.$message({
                    showClose: true,
                    message: "只允许在待提货/待指派状态下修改",
                    type: "error",
                });
                done();
                return;
            }
            if (row.id) {
                if (this.users.length !== 0) {
                    row.engineerId = this.users[0].id ? this.users[0].id : row.engineerId;
                    row.realName = this.users[0].realName ? this.users[0].realName : row.realName;
                }
                row.status = "WAIT_FOR_DELIVERY";
                if (this.warehouse.id) {
                    row.warehouseId = this.warehouse.id;
                    row.warehouseName = this.warehouse.warehouseName;
                }
                updatematerialOrder(row, done)
                    .then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "修改成功",
                                type: "success",
                            });
                            // 清空选中
                            this.warehouse = "";
                            this.users = [];
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error",
                        });
                    });
                done();
            } else {
                const parmas = {
                    phone: row.phone
                };
                addmaterialOrder(parmas)
                    .then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "新增成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        this.tableLoading = false;
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error",
                        });
                    });
                addDone();
            }
        },
        handleEdit(row, index) {
            this.$refs.crud.rowEdit(row, index);

        },
        /* handleView() {
            this.$refs.crud.rowView();
        },
 */
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            this.downloadData = params;
            findmaterialOrder(params).then((res) => {
                console.log('res::: ', res);
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                console.log('this.tableData::: ', this.tableData);
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                // 间隔300毫秒关闭loading
                setTimeout(() => {
                    this.tableLoading = false;
                }, 300);
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map((item) => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        downloadExcelmaterialOrder() {
            let params = this.downloadData;
            params.startTime = this.$refs.crud.searchForm.startTime;
            params.endTime = this.$refs.crud.searchForm.endTime;
            downloadExcelmaterialOrder(params).then((response) => {
                // 提取文件名
                const filename = response.headers["content-disposition"].match(
                    /filename=(.*)/
                )[1];
                // 将二进制流转为blob
                const blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename));
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob);
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", decodeURI(filename));
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL);
                    this.searchChange(params);
                }
            });
        },
        downloadExcelmaterialOrderDetails() {
            let params = this.downloadData;
            params.startTime = this.$refs.crud.searchForm.startTime;
            params.endTime = this.$refs.crud.searchForm.endTime;
            downloadExcelMaterialRetrievalDetails(params).then((response) => {
                // 提取文件名
                const filename = response.headers["content-disposition"].match(
                    /filename=(.*)/
                )[1];
                // 将二进制流转为blob
                const blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename));
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob);
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", decodeURI(filename));
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL);
                    this.searchChange(params);
                }
            });
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel() {
            if (this.$refs.crud.tableSelect.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择要操作的数据",
                    type: "error",
                });
                return;
            }

            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let ids = new Array();
                    for (let row of this.$refs.crud.tableSelect) {
                        ids.push(row.id);
                    }

                    delmaterialOrder(ids)
                        .then((response) => {
                            if (response.code == "200") {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success",
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            this.tableLoading = false;
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error",
                            });
                        });
                })
                .catch(() => { });
        },
    },
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>